export const appConfigData = (state) => state.appConfig.data;
export const appConfigErrors = (state) => state.appConfig.errors;
export const appConfigIsError = (state) => state.appConfig.isError;
export const appConfigIsFetched = (state) => state.appConfig.isFetched;
export const appConfigIsFetching = (state) => state.appConfig.isFetching;
